import ServicesRepeater from './ServicesRepeater'

export default ServicesRepeater
